import IMG from "../../constants/image";
import React, {useEffect, useState} from "react";
import './style.css';
import ProductForm from "./ProductForm";
import {useNavigate, useParams} from "react-router-dom";
import {PATH} from "../../constants";
import {getProductDetail, updateGeneralInfoProduct, updateSaleTypesProduct} from "../../network/api";
import popupStore from "../../store/popupStore";
import appStore from "../../store/appStore";
import {isEmpty} from "lodash";

const EditProduct = () => {
  const navigate = useNavigate();
  const params = useParams()
  const [productDetail, setProductDetail] = useState({});
  const [deletedVariantIds, setDeletedVariantIds] = useState([]);
  const {setPopup} = popupStore() || {}
  const {setLoading} = appStore() || {};

  const {productId} = params || {};

  useEffect(() => {
    // Implement your logic here
    if (productId) {
      getProduct({productId})
    } else {
      navigate(PATH.MANAGING_PRODUCT);
    }
  }, [productId]);

  const getProduct = async ({productId}) => {
    const res = await getProductDetail({productId});
    if (res?.success) {
      setProductDetail(res?.data);
    } else {
      navigate(PATH.MANAGING_PRODUCT);
    }
  }

  const handleSubmitData = async (formData) => {
    const {retails, isWholesale, minOrderQty, minPrice, maxPrice} = formData;
    const items = [];
    const hadWholesaleOnServer = Boolean(
      productDetail?.enable_wholesale || !isEmpty(productDetail?.wholesale)
    );
    const is_disable_wholesale = !isWholesale && hadWholesaleOnServer;

    if (!isEmpty(retails)) {
      retails.forEach(retail => {
        if (retail.id) {
          items.push({
            action: "update",
            variant_id: retail.id,
            retail: {
              variant_name: retail.variant_name,
              unit: retail.unit,
              price: Number(retail.price),
              weight: Number(retail.weight)
            }
          });
        } else {
          items.push({
            action: "create",
            retail: {
              variant_name: retail.variant_name,
              unit: retail.unit,
              price: Number(retail.price),
              weight: Number(retail.weight)
            }
          });
        }
      });
    }

    if (isWholesale) {
      const wholesaleVariantId = productDetail?.wholesale?.id;
      if (wholesaleVariantId && !deletedVariantIds.includes(wholesaleVariantId)) {
        items.push({
          action: "update",
          variant_id: wholesaleVariantId,
          wholesale: {
            min_price: Number(minPrice),
            max_price: Number(maxPrice),
            min_order_qty: Number(minOrderQty),
            unit_of_measure: retails[0]?.unit || "kg"
          }
        });
      }
    }

    deletedVariantIds.forEach(variantId => {
      items.push({
        action: "delete",
        variant_id: variantId
      });
    });

    const newFormData = {
      ...formData,
      items,
      is_disable_wholesale
    };
    const shouldUpdateSaleTypes =
      !isEmpty(items) || is_disable_wholesale;
    const res = shouldUpdateSaleTypes
      ? await updateSaleTypesProduct(newFormData)
      : '';
    const resGeneralInfo = await updateGeneralInfoProduct(newFormData);
    setLoading(false);

    if (resGeneralInfo?.success) {
      setPopup({
        isOpen: true,
        data: {
          title: 'Bạn đã chỉnh sửa sản phẩm thành công',
          desc: 'Trang web đang tự động chuyển đến trang Quản lý sản phẩm',
          image: IMG.createProductSuccess,
          autoAccept: 8,
          accept: {
            label: 'Về trang cửa hàng',
            action: () => {
              setPopup({});
              navigate(PATH.MANAGING_PRODUCT);
            }
          }
        }
      });
    }
    return res;
  };

  return (
    <div className=''>
      <div className='flex justify-center items-center gap-[5px] mb-2.5'>
        <img className='' src={IMG.icon.boxBorderGreen} alt="boxBorderGreen"/>
        <p className='text-sm md:text-xl font-bold'>Chỉnh sửa sản phẩm</p>
      </div>
      <div className='bg-white rounded-xl w-full'>
        <ProductForm
          editing
          productDetail={productDetail}
          actionSubmit={handleSubmitData}
          buttonSubmit='Chỉnh sửa sản phẩm'
          setDeletedVariantIds={setDeletedVariantIds}
        />
      </div>
    </div>
  )
};

export default EditProduct;
